// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".shop-menu .drawer{max-height:100%}.shop-menu .drawer__container{display:flex;flex-direction:column;flex-grow:1;max-height:100%;overflow-x:hidden;overflow-y:auto}.shop-menu .drawer__content{flex-grow:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
